import { readCookie } from '@zapier/cookies';
import { emit } from '@zapier/events-toolkit-browser';
import { useCallback } from 'react';
import { useRendererContext } from '../content-renderers/RendererContext';
import { useBlockContext } from '../BlockContext';
import { LIB_VERSION } from '../version';
export var EventType;
(function (EventType) {
    EventType["PageViewEvent"] = "web_analytics.tracking.page_view.PageViewEvent";
    EventType["UserInteractionEvent"] = "web_analytics.tracking.user_interaction.UserInteractionEvent";
    EventType["PackageComponentLoadEvent"] = "web_analytics.tracking.package.PackageComponentLoadEvent";
})(EventType || (EventType = {}));
export function useTracking() {
    var _a, _b, _c, _d;
    const { serviceName, contentID, name, variations, model } = useRendererContext();
    const blockContext = useBlockContext();
    const componentName = (_b = (_a = blockContext === null || blockContext === void 0 ? void 0 : blockContext.builderBlock) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.name;
    const layerName = (_d = (_c = blockContext === null || blockContext === void 0 ? void 0 : blockContext.builderBlock) === null || _c === void 0 ? void 0 : _c.layerName) !== null && _d !== void 0 ? _d : componentName;
    const _emit = useCallback((eventDetails, eventType) => {
        var _a, _b;
        const builderABTestID = contentID
            ? readCookie(`builder.tests.${contentID}`)
            : null;
        const builderABTestVariationName = builderABTestID
            ? (_b = (_a = variations === null || variations === void 0 ? void 0 : variations[builderABTestID]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'control'
            : null;
        const experiment_flag = !!builderABTestVariationName;
        return emit(Object.assign(Object.assign({ system_name: serviceName, experiment_flag }, (experiment_flag && {
            experiment_name: `experiment_name=${name}--variant_name=${builderABTestVariationName}`,
        })), eventDetails), eventType);
    }, [contentID, serviceName, variations, name]);
    const emitPageViewEvent = useCallback((eventDetails) => {
        return _emit(eventDetails, EventType.PageViewEvent);
    }, [_emit]);
    const emitUserInteractionEvent = useCallback((eventDetails) => {
        const hasCustomTrackingFields = !!(eventDetails === null || eventDetails === void 0 ? void 0 : eventDetails.custom_tracking_fields) ||
            !!componentName ||
            !!layerName;
        return _emit(Object.assign(Object.assign({}, eventDetails), (hasCustomTrackingFields && {
            custom_tracking_fields: Object.assign({ component_name: componentName, layer_name: layerName, model }, eventDetails.custom_tracking_fields),
        })), EventType.UserInteractionEvent);
    }, [_emit, layerName, componentName, model]);
    const emitPackageComponentLoadEvent = useCallback((eventDetails) => {
        return _emit(Object.assign(Object.assign({}, eventDetails), { package_version: LIB_VERSION, package_name: '@zapier/builder.io-kit', component_name: model }), EventType.PackageComponentLoadEvent);
    }, [_emit, model]);
    return {
        emit: _emit,
        emitPageViewEvent,
        emitUserInteractionEvent,
        emitPackageComponentLoadEvent,
    };
}
//# sourceMappingURL=useTracking.js.map